export default {
    searchForm: document.querySelector('#search-form'),
    input: document.querySelector('.input-js'),
    movieList: document.querySelector('.js-movieList'),
    prevBtn: document.querySelector('[data-action="prev"]'),
    nextBtn: document.querySelector('[data-action="next"]'),
    pageValue: document.querySelector('.homePage__value'),
    errorRef: document.querySelector('.error-message'),
    title: document.querySelector('.title'),
    buttonContainer: document.querySelector('.homePage__button'),
    homePage: document.querySelector('.homepage-section'),
    logotype: document.querySelector('.logotype'),
    libraryPage: document.querySelector('.library-section'),
    detailsSectionBlock: document.querySelector('.details'),
    addQueueBtn: document.querySelector('.js-details__queue'),
    addWatchedBtn: document.querySelector('.js-details__watched'),
    iconQueue: document.querySelector('.js-icon-queue'),
    iconWatched: document.querySelector('.js-icon-watched'),
    footerContainer: document.querySelector('.footer'),
    btnToWatchList: document.querySelector('#js-buttonWatched'),
    btnToQueueList: document.querySelector('#js-buttonQueue'),
    libraryBtnContainer: document.querySelector('.library-button-container'),
    linkLibrary: document.querySelector('#js-link-library'),
    linkHomePage: document.querySelector('#js-link-homepage'),
    linkLogotype: document.querySelector('#js-logotype'),
    libraryList: document.querySelector('.libraryPage-list'),
    backToTopBtn: document.querySelector('.btn-up'),
}

